export default function CardTitle({ pathway, userPathway, progress }) {
  const isCompleted = Boolean(userPathway?.completedAt);
  const statusLabel = isCompleted ? 'Completed' : 'In Progress';
  const safePercent = Math.max(0, Math.min(100, Number(progress?.percent) || 0));

  return (
    <div className="my-pathway-title-wrap">
      <div className="my-pathway-title-top">
        <img
          src={pathway.logo}
          alt={`${pathway.name} logo`}
          className="my-pathway-logo"
        />
        <span className={`my-pathway-status-pill ${isCompleted ? 'my-pathway-status-pill--completed' : 'my-pathway-status-pill--active'}`}>
          {statusLabel}
        </span>
      </div>
      <h4 className="my-pathway-name">{pathway.name}</h4>
      <div className="my-pathway-progress-wrap" aria-label="Pathway progress">
        <div className="my-pathway-progress-meta">
          <span>Selected {progress?.selectedProjects || 0}/{progress?.totalProjects || 0}</span>
          <span>Completed {progress?.completedRequired || 0}/{progress?.requiredProjects || 0} required</span>
        </div>
        <div className="my-pathway-progress-track">
          <span className="my-pathway-progress-fill" style={{ width: `${safePercent}%` }} />
        </div>
      </div>
    </div>
  );
}